import {customPluginNameAttr} from "@/components/tinyMce/plugins/tinyMceCustomPluginsConstants";

const t: any = {
  "fr": {
    "toolbarTooltip": "Téléverser une image",
    "dialog": {
      "title": "Téléverser une image",
      "chooseImgPlaceholder": "Sélectionner une image (max {maxSize} Mo)",
      "imageSizeLabel": "Taille",
      'customUploadButtonLabel': 'Téléverser une image',
      'noFileSelected': 'Aucun fichier sélectionné',
      "sizeOptions": {
        "min": "Petit",
        "mid": "Moyen",
        "big": "Grand",
        "fullPage": "Pleine page"
      },
      "actions": {
        "upload": "Téléverser",
        "cancel": "Annuler"
      }
    }
  },
  "en": {
    'toolbarTooltip': 'Upload image',
    'dialog': {
      'title': 'Upload image',
      'chooseImgPlaceholder': 'Select image (max {maxSize} MB)',
      'imageSizeLabel': 'Size',
      'customUploadButtonLabel': 'Upload an image',
      'noFileSelected': 'No file selected',
      "sizeOptions": {
        "min": "Min",
        "mid": "Mid",
        "big": "Big",
        "fullPage": "Full Page",
      },
      'actions': {
        'upload': 'Upload',
        'cancel': 'Cancel',
      }
    }
  },
  "de": {
    "toolbarTooltip": "Bild hochladen",
    "dialog": {
      "title": "Bild hochladen",
      "chooseImgPlaceholder": "Bild auswählen (max. {maxSize} MB)",
      "imageSizeLabel": "Größe",
      'customUploadButtonLabel': 'Ein Bild hochladen',
      'noFileSelected': 'Keine Datei ausgewählt',
      "sizeOptions": {
        "min": "Klein",
        "mid": "Mittel",
        "big": "Groß",
        "fullPage": "Ganze Seite"
      },
      "actions": {
        "upload": "Hochladen",
        "cancel": "Abbrechen"
      }
    }
  },
  "es": {
    "toolbarTooltip": "Subir imagen",
    "dialog": {
      "title": "Subir imagen",
      "chooseImgPlaceholder": "Seleccionar imagen (máx. {maxSize} MB)",
      "imageSizeLabel": "Tamaño",
      'customUploadButtonLabel': 'Subir una imagen',
      'noFileSelected': 'Ningún archivo seleccionado',
      "sizeOptions": {
        "min": "Pequeño",
        "mid": "Mediano",
        "big": "Grande",
        "fullPage": "Página completa"
      },
      "actions": {
        "upload": "Subir",
        "cancel": "Cancelar"
      }
    }
  }
}

export const customImageUploaderPluginName = 'customimageupload';

export const useCustomImageUploader = (editor: any) => {
  const lang = editor.getParam('customimageupload_i18n_locale', 'en').toLowerCase();
  const uploadUrl = editor.getParam('customimageupload_uploadUrl', '/user/lib/photo');
  const maxFileSizeMB = editor.getParam('customimageupload_maxFileSizeMB', 2); // in MB

  const maxSize = maxFileSizeMB * 1024 * 1024;
  const sizes = [
    {value: '50', text: t[lang].dialog.sizeOptions.min},
    {value: '255', text: t[lang].dialog.sizeOptions.mid},
    {value: '500', text: t[lang].dialog.sizeOptions.big},
    {value: '1000', text: t[lang].dialog.sizeOptions.fullPage}
  ];

  editor.ui.registry.addButton(customImageUploaderPluginName, {
    icon: 'image',
    tooltip: t[lang].toolbarTooltip,
    onAction: () => {
      editor.windowManager.open({
        title: t[lang].dialog.title,
        initialData: {
          size: sizes[1].value
        },
        body: {
          type: 'panel',
          items: [
            {
              type: 'htmlpanel',
              html: `
                    <div style="margin-bottom: 10px;">
                      <label style="display: block; margin-bottom: 5px; font-weight: bold;">
                        ${t[lang].dialog.chooseImgPlaceholder.replace('{maxSize}', maxFileSizeMB)} :
                      </label>

                      <button id="tmce-upload-btn"
                          style="display: inline-block; background: white; color: grey; padding: 4px 12px; cursor: pointer; border: 1px solid #000;
                            border-radius: 4px; font-size: 14px;">
                        ${t[lang].dialog.customUploadButtonLabel}
                      </button>

                      <span id="tmce-file-name-label" style="margin-left: 8px; font-style: italic; font-size: 14px;">
                        ${t[lang].dialog.noFileSelected}
                      </span>

                      <input type="file"
                        id="tmce-tinymce-image-upload"
                        accept="image/*"
                        style="display: none;" />
                    </div>
                    <div id="tmce-image-preview" style="margin: 10px 0; text-align: center;"></div>
                `
            },
            {
              type: 'selectbox',
              name: 'size',
              label: t[lang].dialog.imageSizeLabel,
              items: sizes
            }
          ]
        },
        buttons: [
          {
            type: 'cancel',
            text: t[lang].dialog.actions.cancel
          },
          {
            type: 'submit',
            text: t[lang].dialog.actions.upload,
            primary: true
          }
        ],
        onSubmit: async (api: any) => {
          const data = api.getData();
          const fileInput = document.getElementById('tmce-tinymce-image-upload') as HTMLInputElement;
          const file = fileInput?.files?.[0];

          if (!file) {
            editor.dispatch('customImageUploadNoFileSelected');
            return;
          }

          if (file.size > maxSize) {
            editor.dispatch('customImageUploadMaxSizeExceedError', {maxFileSizeMB});
            return;
          }

          try {
            const formData = new FormData();
            formData.append('image', file);
            formData.append('size', data.size);
            const response = await fetch(uploadUrl, {
              method: 'POST',
              body: formData
            });

            if (!response.ok) {
              console.log(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            // Insérer l'image dans l'éditeur
            editor.insertContent(`&nbsp<img ${customPluginNameAttr}="${customImageUploaderPluginName}" src="${result.dataValue}" contenteditable="false"/>`);

            api.close();
          } catch (error: any) {
            console.error('Upload error:', error);
            editor.dispatch('customImageApiError');
          }
        }
      });

      // Ajouter la preview après ouverture de la modal
      setTimeout(() => {
        const uploadBtn = document.getElementById('tmce-upload-btn');
        const fileInput = document.getElementById('tmce-tinymce-image-upload') as HTMLInputElement;
        const previewContainer = document.getElementById('tmce-image-preview');
        const fileNameLabel = document.getElementById('tmce-file-name-label');

        uploadBtn?.addEventListener("click", () => fileInput?.click());

        if (fileInput && previewContainer) {
          setFileInputEventListener(fileInput, fileNameLabel, previewContainer);
        }
      }, 100);

      function setFileInputEventListener(fileInput: HTMLInputElement, fileNameLabel: HTMLElement|null, previewContainer: HTMLElement) {
        fileInput.addEventListener('change', (e) => {
          const file = (e.target as HTMLInputElement).files?.[0];
          if (file?.type.startsWith('image/')) {
            if (fileNameLabel) {
              fileNameLabel.textContent = file.name;
            }

            const reader = new FileReader();
            reader.onload = (event) => {
              const targetSrc: string = (event.target?.result || '') as string;
              previewContainer.innerHTML = `
                    <img
                      src="${targetSrc}"
                      style="max-width: 100%; max-height: 200px; border: 1px solid #ddd; border-radius: 4px;"
                    />
                  `;
            };
            reader.readAsDataURL(file);
          }
        });
      }
    }
  });
};

